<div>
  <span *ngIf="!isPlaying" class="fa fa-play" aria-hidden="true" (click)="onPlayOrPause()"></span>
  <span *ngIf="isPlaying" class="fa fa-pause" aria-hidden="true" (click)="onPlayOrPause()"></span>
</div>